import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../seo/Seo';
import './ContentPage.css';

// Shown for any address that is not a page. Not indexed by search engines.
const NotFound = () => (
  <div className="content-page">
    <Seo title="Page not found | KS Montessori & Secondary School" noindex />
    <section className="section">
      <div className="container content-container">
        <h1>Page not found</h1>
        <p>Sorry, we could not find that page. It may have moved, or the address may be mistyped.</p>
        <ul className="not-found-links">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/admissions">Admissions</Link></li>
          <li><Link to="/contact">Contact us</Link></li>
        </ul>
      </div>
    </section>
  </div>
);

export default NotFound;
